import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This key is used to track useFetchLastTrayDetails
 */
export const LAST_CREATED_TRAY_DETAILS_QUERY_KEY =
  'last-created-tray-details-query-key';

/**
 * This hook fetches the last created tray details.
 */
export const useFetchLastTrayDetails = () => {
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      queryKey: [LAST_CREATED_TRAY_DETAILS_QUERY_KEY],
      networkMode: 'always',
      retry: false,
      queryFn: INV_MGMT_SERVICE_API.getLastTrayDetails,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
